import { render, staticRenderFns } from "./VersionSelectEn.vue?vue&type=template&id=fc5d3b80&"
import script from "./VersionSelectEn.vue?vue&type=script&lang=js&"
export * from "./VersionSelectEn.vue?vue&type=script&lang=js&"
import style0 from "./VersionSelectEn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports